import DiscoverView from './DiscoverView';
import './DiscoverView.scss';

export default DiscoverView;
